module.exports = __webpack_public_path__ + "img/concept-tool-calling.42804af9.svg";